export enum DevelopmentSlug {
    RICHMOND_HOUSE = 'richmond-house',
    VITA_STUDENT_PEDRALBES = 'vita-student-pedralbes',
    PORTLAND_HOUSE = 'portland-house',
    VITA_STUDENT_AT_STRAWBERRY_PLACE_NEWCASTLE = 'vita-student-at-strawberry-place-newcastle',
    VITA_STUDENT_EDINBURGH = 'vita-student-edinburgh',
    VITA_STUDENT_LEWISHAM = 'vita-student-lewisham',
    COVENTRY_CANNON_PARK = 'coventry-cannon-park',
    VITA_STUDENT_CARDIFF = 'vita-student-cardiff',
    FIRST_STREET = 'first-street',
    VITA_STUDENT_AT_PORTSWOOD_SOUTHAMPTON = 'vita-student-at-portswood-southampton',
    VITA_STUDENT_POBLENOU = 'vita-student-poblenou',
    TELEPHONE_HOUSE = 'telephone-house',
    BELFAST_BRUCE_STREET = 'belfast-bruce-street',
    VITA_STUDENT_MANCHESTER_CIRCLE_SQUARE = 'vita-student-manchester-circle-square',
    VITA_STUDENT_LEEDS = 'vita-student-leeds',
    VITA_STUDENT_BIRMINGHAM = 'vita-student-birmingham',
    EDINBURGH_IONA_STREET = 'edinburgh-iona-street',
    VITA_STUDENT_NOTTINGHAM = 'vita-student-nottingham',
    CROSSHALL_STREET = 'crosshall-street',
    LEEDS_PORTLAND_CRESCENT = 'leeds-portland-crescent',
    ZED_ALLEY = 'zed-alley',
    COVENTRY_COPPER_TOWERS = 'coventry-copper-towers',
    VITA_STUDENT_YORK = 'vita-student-york',
    VITA_STUDENT_GLASGOW = 'vita-student-glasgow',
    WESTGATE = 'westgate',
    HOUSE_OF_SOCIAL = 'house-of-social-first-street',
}
